<template>
  <div class="mykeys_page">
    <div class="tab_box">
      <div
        class="tab_item"
        :class="{ is_active: activeTab === 0 }"
        @click="setActiveTab(0)"
        tracker-eventcode="djTablAPI_keygl_000"
      >
        API Key管理
      </div>
      <div
        class="tab_item"
        :class="{ is_active: activeTab === 1 }"
        @click="setActiveTab(1)"
        tracker-eventcode="djTablxh_000"
      >
        消耗
      </div>
    </div>
    <div class="content_area" v-if="activeTab === 0">
      <div class="keys_area" v-if="keyList.length">
        <div class="key_box" v-for="(item, index) in keyList" :key="index">
          <div class="key_top">
            <div class="key_title">{{ item.description }}</div>

            <div class="del_box" @click="delKeyMed(item)">
              <div class="ic_del">
                <img src="./images/ic_del.png" alt="" />
              </div>
              删除密钥
            </div>
          </div>
          <div class="key_inner">
            <div class="key_tag">
              {{ item.showPlain ? item.apiKey : item.maskedApiKey }}
            </div>
            <div class="card_actions">
              <div
                class="action_icon view_icon"
                @click="handleView(index)"
                :tracker-eventcode="
                  item.showPlain ? 'yzwdkey_000' : 'ckwdkey_000'
                "
              >
                <img
                  v-if="item.showPlain"
                  src="./images/ic_eye.png"
                  alt="查看"
                />
                <img v-else src="./images/ic_hide.png" alt="查看" />
              </div>
              <div
                class="action_icon"
                @click="handleCopy(item.apiKey)"
                tracker-eventcode="fzapikey_000"
              >
                <img src="./images/ic_copy2.png" alt="复制" />
              </div>
            </div>
          </div>
          <div class="create_time">
            创建于{{ formatDate(item.createTime) || "-" }}
          </div>
          <div class="update_time" v-if="activatedTime">
            已激活，{{ formatDate(activatedTime) }}更新
          </div>
        </div>
      </div>
      <div class="empty_state" v-if="!keyList.length">暂无API Key</div>

      <div class="safety_block">
        <div class="safety_title">安全提示</div>
        <div class="tips_item" v-for="(tip, index) in tips" :key="index">
          <span class="check_icon">
            <img src="./images/right.png" alt="提示" />
          </span>
          <span>{{ tip }}</span>
        </div>
      </div>
    </div>

    <div class="bottom_fixed" v-if="activeTab === 0">
      <div class="bottom_btn" @click="openCreatePopup">
        <div class="icon_book">
          <img src="./images/ic_add.png" alt="" />
        </div>
        创建新密钥
      </div>
    </div>
    <!-- <Consume v-else-if="activeTab === 1"></Consume> -->
    <div class="content_area" v-if="activeTab === 1">
      <div class="vip_box">
        <div class="vip_top">
          <div class="letf_title">会员等级及套餐权益</div>
          <!-- <div class="top_right">
            权益说明
            <div class="arrow">
              <img src="./images/vip_arrow.png" alt="" />
            </div>
          </div> -->
        </div>
        <div class="vip_main">
          <div class="top_info">
            <div class="my_icon">
              <img :src="dealImgMed()" alt="" />
            </div>
            <div class="vip_info">
              <div class="info_top">
                <div class="info_name">
                  <span v-if="isVip == 'MXSKILLSL2YH'">旗舰版</span>
                  <span v-else-if="isVip == 'MXSKILLSL1YH'">进阶版</span>
                  <span v-else>免费版</span>
                </div>
                <div class="info_time" v-if="isVip">{{ vipEndTime }}到期</div>
                <div
                  class="vip_entry"
                  @click="goToVipPage"
                  :tracker-eventcode="isVip ? 'djhyzx_000' : 'djsjqy_000'"
                >
                  <img v-if="isVip" src="./images/ic_entry.png" alt="" />
                  <img v-else src="./images/ic_entry2.png" alt="" />
                </div>
              </div>
              <div class="info_text" v-if="isVip == 'MXSKILLSL2YH'">
                您当前为旗舰版套餐，限时享有基础调用600次权益。
              </div>
              <div class="info_text" v-else-if="isVip == 'MXSKILLSL1YH'">
                您当前为进阶版套餐，限时享有基础调用300次权益；满足相关条件后，您可以每月前往账户等级专区领取该套餐。
              </div>
              <div class="info_text" v-else>
                您当前为免费版套餐，享有基础调用50次权益，您可以通过完成平台指定任务<span
                  >升级权益</span
                >
              </div>
            </div>
          </div>
          <div class="info_tips" v-if="isVip">
            <span>限时回馈东方财富用户</span>，每日加赠200次调用次数。
          </div>
          <div class="info_tips" v-else>
            <span>限时回馈东方财富用户</span>，每日加赠100次调用次数。
          </div>
        </div>
      </div>
      <div class="key_card" v-for="(item, index) in skillList" :key="index">
        <div class="card_header">
          <div class="title">{{ item.skillName }}</div>
        </div>
        <div class="usage_row">
          <span>今日调用</span>
          <span>{{ item.todayUsage }}/{{ item.dailyLimit }} 次</span>
        </div>
        <div class="progress_track">
          <div
            class="progress_fill"
            :style="{ width: `${(item.todayUsage / item.dailyLimit) * 100}%` }"
          ></div>
        </div>
      </div>
      <div class="empty_state" v-if="!skillList.length">暂无API Key</div>
      <div class="safety_block">
        <div class="safety_title">安全提示</div>
        <div class="tips_item" v-for="(tip, index) in tips" :key="index">
          <span class="check_icon">
            <img src="./images/right.png" alt="提示" />
          </span>
          <span>{{ tip }}</span>
        </div>
      </div>
    </div>
    <CreateApiKeyPopup
      v-model="createPopupVisible"
      @confirm="handleCreateConfirm"
    />
    <ConfirmPop
      v-if="showConfirmPop"
      :keyItem="delKeyItem"
      @handleConfirmPop="handleConfirmPop"
    ></ConfirmPop>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch, computed } from "vue";
import fetchData from "@/utils/fetchData";
import { $loading, $toast } from "@/utils/globalUtils";
import copyText from "@/utils/copy";
import CreateApiKeyPopup from "./components/CreateApiKeyPopup.vue";
import Consume from "./components/Consume.vue";
import { appConfirm } from "@eastmoney/mku";
import ConfirmPop from "@/components/ConfirmPop.vue";
import router from "@/router";
import { useRoute } from "vue-router";
import { copyContent } from "@/utils/common";

import { useMainStore } from "@/pinia/main";
import { storeToRefs } from "pinia";
const mainStore = useMainStore();
const { userObj, activatedTime } = storeToRefs(mainStore);

type SkillItem = {
  id: number;
  name: string;
  apiKey: string;
  maskedApiKey: string;
  createDate: string;
  todayUsage: number;
  dailyLimit: number;
  progressPercent: number;
  showPlain: boolean;
};

type ApiKeyUsageItem = {
  dailyLimit: number;
  description: string;
  maskedApiKey: string;
  skillName: string;
  todayUsage: number;
  createTime: number;
  apiKey: string;
};

// const skillList = ref<SkillItem[]>([]);
const skillList = ref<any[]>([]);
const keyList = ref<any[]>([]);
const activeTab = ref(0);
const route = useRoute();
const createPopupVisible = ref(false);
const maskedApiKey = ref("");
const apiKey = ref("");
const keyCreateTime = ref("");
const isVip = ref("");
const vipEndTime = ref("");
const VIP_CACHE_KEY = "mykeys_vip_info";

const tips: string[] = [
  "请勿将API Key发布到公开渠道(如GitHub、论坛等)",
  "建议为不同项目使用不同的API Key，便于管理和追踪",
  "如发现异常调用，请立即删除并重新生成API Key",
];
const showConfirmPop = ref(false);
const delKeyItem = ref<any>({});

const readVipCache = () => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    const cache = window.localStorage.getItem(VIP_CACHE_KEY);
    if (!cache) {
      return;
    }
    const parsed = JSON.parse(cache);
    if (parsed?.isVip && parsed?.vipEndTime) {
      isVip.value = String(parsed.isVip);
      vipEndTime.value = String(parsed.vipEndTime);
    }
  } catch (error) {
    window.localStorage.removeItem(VIP_CACHE_KEY);
  }
};

const writeVipCache = (roleCode: string, endTime: string) => {
  if (typeof window === "undefined") {
    return;
  }
  if (!roleCode || !endTime) {
    window.localStorage.removeItem(VIP_CACHE_KEY);
    return;
  }
  window.localStorage.setItem(
    VIP_CACHE_KEY,
    JSON.stringify({
      isVip: roleCode,
      vipEndTime: endTime,
    })
  );
};

const normalizeActiveTab = (value: unknown) => {
  const rawValue = Array.isArray(value) ? value[0] : value;
  const tabValue = String(rawValue);
  return tabValue === "1" || tabValue === "2" ? 1 : 0;
};

const getRouteActiveTabValue = (tab: number) => {
  return tab === 1 ? "2" : "0";
};

const syncRouteActiveTab = () => {
  const currentTab = Array.isArray(route.query.activeTab)
    ? route.query.activeTab[0]
    : route.query.activeTab;
  const nextTab = getRouteActiveTabValue(activeTab.value);

  if (String(currentTab) === nextTab) {
    return;
  }

  router.replace({
    path: route.path,
    query: {
      ...route.query,
      activeTab: nextTab,
    },
  });
};

const setActiveTab = (tab: number) => {
  if (tab !== 0 && tab !== 1) {
    return;
  }
  activeTab.value = tab;
  syncRouteActiveTab();
};

const syncActiveTabFromRoute = () => {
  activeTab.value = normalizeActiveTab(route.query.activeTab);
};

onMounted(() => {
  syncActiveTabFromRoute();
  readVipCache();
  getKeyList();
  getVipStatus();
  window.pageLoadMed();
});

watch(
  () => route.query.activeTab,
  () => {
    syncActiveTabFromRoute();
  }
);

const formatDate = (timestamp: number) => {
  if (!timestamp) {
    return "";
  }
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}年${month}月${day}日`;
};

const getProgressPercent = (todayUsage: number, dailyLimit: number) => {
  if (!dailyLimit || dailyLimit <= 0) {
    return 0;
  }
  const percent = Math.round((todayUsage / dailyLimit) * 100);
  if (percent < 0) {
    return 0;
  }
  if (percent > 100) {
    return 100;
  }
  return percent;
};

const getKeyList = () => {
  $loading.show();
  const obj = {
    api: "/apikey/usage",
    data: {
      st: new Date().getTime(),
    },
    success: (res: any) => {
      if (res && res.status === 0 && res.data) {
        let resp = res.data;
        skillList.value = resp.skills || [];
        let keys = resp.keys || [];
        keyList.value = keys.map((item: any) => ({
          ...item,
          showPlain: false,
        }));
      } else {
        keyList.value = [];
        skillList.value = [];
      }
      $loading.hide();
    },
    fail: () => {
      keyList.value = [];
      skillList.value = [];
      $loading.hide();
    },
  };

  fetchData.doGet(obj);
};

const getVipStatus = () => {
  const obj = {
    api: "/api/benefit/query/queryEndTime",
    data: {},
    success: (res: any) => {
      if (
        res &&
        res.status === 0 &&
        res.data &&
        res.data.endDate &&
        res.data.roleCode
      ) {
        isVip.value = res.data.roleCode;
        vipEndTime.value = res.data.endDate;
        writeVipCache(res.data.roleCode, res.data.endDate);
      } else {
        isVip.value = "";
        vipEndTime.value = "";
        writeVipCache("", "");
      }
    },
    fail: () => {
      isVip.value = "";
      vipEndTime.value = "";
      writeVipCache("", "");
    },
  };

  fetchData.doPost(obj);
};

const handleView = (index: number) => {
  if (index < 0 || index >= keyList.value.length) {
    return;
  }
  keyList.value[index].showPlain = !keyList.value[index].showPlain;
};

const handleCopy = (text: string) => {
  if (!text) {
    $toast.show("暂无可复制的API Key", 3000);
    return;
  }

  copyContent({
    content: text,
    callback: (isSuccess: any) => {
      if (isSuccess) {
        $loading.hide();
        $toast.show("复制成功", 3000);
      } else {
        $loading.hide();
        $toast.show("复制失败，请长按手动复制", 3000);
      }
    },
  });
};

const openCreatePopup = () => {
  createPopupVisible.value = true;
};

// 创建密钥
const handleCreateConfirm = (name: string) => {
  if (!name) {
    $toast.show("请输入密钥名称");
    return;
  }
  $loading.show();
  let obj = {
    api: "/apikey/create",
    data: {
      description: name,
    },
    success: (res: any) => {
      if (res && res.status === 0) {
        createPopupVisible.value = false;
        $toast.show(`创建密钥成功`, 3000);
        getKeyList();
      } else {
        $toast.show(res.message || "创建密钥失败", 3000);
      }
      $loading.hide();
    },
    fail: () => {
      $loading.hide();
      $toast.show("服务繁忙，请稍后再试", 3000);
    },
  };
  fetchData.doPost(obj);
};
// 删除密钥
const delKeyMed = (item: any) => {
  if (keyList.value.length <= 1) {
    $toast.show("至少保留一个API Key", 3000);
    return;
  }
  showConfirmPop.value = true;
  delKeyItem.value = item;
};
const handleConfirmPop = (isConfirm: boolean, apiKey?: string) => {
  if (!isConfirm || !apiKey) {
    showConfirmPop.value = false;
    return;
  } else if (isConfirm) {
    $loading.show();
    let obj = {
      api: "/apikey/delete",
      data: {
        apiKey: apiKey,
      },
      success: (res: any) => {
        if (res && res.status === 0) {
          $toast.show("删除成功", 3000);
          getKeyList();
        } else {
          $toast.show(res.message || "删除密钥失败", 3000);
        }
        showConfirmPop.value = false;
        $loading.hide();
      },
      fail: () => {
        $loading.hide();
        showConfirmPop.value = false;
        $toast.show("服务繁忙，请稍后再试", 3000);
      },
    };
    fetchData.doPost(obj);
  }
};
const dealImgMed = () => {
  return `https://avator.eastmoney.com/qface/${userObj.value?.uid}/120`;
};
const goToVipPage = () => {
  router.push({
    path: "/vippage",
  });
};
</script>

<style scoped lang="scss">
.mykeys_page {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  background: rgb(248, 248, 250);
  box-sizing: border-box;
  padding-bottom: 1rem;
  .tab_box {
    width: 100%;
    height: 0.8rem;
    display: flex;
    background: #fff;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    .tab_item {
      position: relative;
      flex: 1;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.32rem;
      color: #333;

      &.is_active {
        color: #ff5500;
        font-weight: bold;
        &::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 0.42rem;
          height: 0.04rem;
          transform: translateX(-50%);
          border-radius: 0.04rem;
          background: #ff5500;
        }
      }
    }
  }
  .content_area {
    position: absolute;
    top: 0.8rem;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    box-sizing: border-box;
    padding: 0.2rem 0.32rem 1.7rem;
    .keys_area {
      width: 100%;
      margin: 0 auto;
      padding: 0.24rem 0;
      .key_box {
        padding: 0.24rem;
        margin-bottom: 0.24rem;
        border-radius: 0.24rem;
        background: #fff;

        .key_top {
          display: flex;
          justify-content: space-between;
          .key_title {
            font-size: 0.32rem;
            color: #333333;
            font-weight: bold;
          }
          .del_box {
            flex-shrink: 0;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 1.64rem;
            height: 0.56rem;
            font-size: 0.24rem;
            color: #333333;
            background: #ffffff;
            border: 0.02rem solid rgba(0, 0, 0, 0.2);
            border-radius: 0.4rem;
            .ic_del {
              margin-right: 0.06rem;
              width: 0.28rem;
              height: 0.26rem;
              font-size: 0;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .key_inner {
          margin-top: 0.36rem;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;

          .key_tag {
            // width: 5.2rem;
            padding: 0.06rem 0.14rem;
            background: #f8f8fa;
            border-radius: 0.1rem;
            color: #333333;
            font-size: 0.28rem;
            letter-spacing: 0.01rem;
            word-break: break-all;
          }

          .card_actions {
            flex-shrink: 0;
            display: flex;
            justify-content: space-around;
            width: 1.4rem;
            padding-left: 0.16rem;
            .action_icon {
              width: 0.4rem;
              height: 0.4rem;
              font-size: 0;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
            }

            .view_icon {
              .eye_slash {
                display: none;
              }

              &:not(.is_plain) {
                .eye_slash {
                  display: block;
                  position: absolute;
                  left: 0.04rem;
                  right: 0.04rem;
                  top: 0.18rem;
                  height: 0.03rem;
                  background: #666;
                  border-radius: 0.02rem;
                  transform: rotate(-28deg);
                  transform-origin: center;
                }
              }
            }
          }
        }

        .create_time {
          margin-top: 0.18rem;
          color: #999999;
          font-size: 0.24rem;
        }
        .update_time {
          color: #999999;
          font-size: 0.24rem;
        }
      }
    }
    .common_title {
      padding-bottom: 0.24rem;
      padding-left: 0.24rem;
      line-height: 1.6;
      font-size: 0.38rem;
      font-weight: bold;
      color: #ff5500;
    }
    .key_card {
      position: relative;
      background: #fff;
      border-radius: 0.24rem;
      padding: 0.24rem;
      margin-bottom: 0.18rem;

      .card_header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          font-size: 0.32rem;
          line-height: 0.46rem;
          color: #333333;
          font-weight: 600;
        }

        .delete_btn {
          display: inline-flex;
          align-items: center;
          height: 0.52rem;
          border: 0.02rem solid #dedede;
          border-radius: 0.12rem;
          color: #666;
          font-size: 0.24rem;
          padding: 0 0.14rem;

          .delete_icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 0.28rem;
            height: 0.26rem;
            margin-right: 0.06rem;
            font-size: 0;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .usage_row {
        margin-top: 0.26rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        font-size: 0.24rem;
      }

      .progress_track {
        margin-top: 0.16rem;
        height: 0.12rem;
        border-radius: 999px;
        background: #ececee;
        overflow: hidden;

        .progress_fill {
          height: 100%;
          border-radius: 999px;
          background: #ff5a00;
        }
      }
    }

    .empty_state {
      margin-top: 0.2rem;
      min-height: 5.2rem;
      border-radius: 0.24rem;
      background: #fff;
      color: #999;
      font-size: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .safety_block {
      margin-top: 0.24rem;
      padding-left: 0.08rem;
      padding-right: 0.08rem;
      .safety_title {
        font-size: 0.28rem;
        color: #333;
        font-weight: 600;
      }

      .tips_item {
        margin-top: 0.16rem;
        display: flex;
        align-items: flex-start;
        font-size: 0.28rem;
        color: #666;
        line-height: 0.44rem;
        .check_icon {
          margin-top: 0.04rem;
          margin-right: 0.1rem;
          flex-shrink: 0;
          width: 0.36rem;
          height: 0.36rem;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .vip_box {
    width: 100%;
    margin-top: 0.2rem;
    margin-bottom: 0.32rem;
    border-radius: 0.36rem;
    overflow: hidden;
    .vip_top {
      display: flex;
      // align-items: center;
      box-sizing: border-box;
      padding-left: 0.32rem;
      padding-right: 0.32rem;
      padding-top: 0.16rem;
      justify-content: space-between;
      width: 100%;
      height: 1.28rem;
      background-image: linear-gradient(
        180deg,
        #fff2ec 0%,
        rgba(255, 229, 218, 0) 100%
      );
      .letf_title {
        font-size: 0.32rem;
        font-weight: bold;
        color: #222222;
      }
      .top_right {
        // background-color: red;
        display: flex;
        align-items: center;
        font-size: 0.22rem;
        height: 0.48rem;
        color: #333333;
        .arrow {
          margin-left: 0.04rem;
          width: 0.12rem;
          height: 0.2rem;
          font-size: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .vip_main {
      position: relative;
      margin-top: -0.5rem;
      width: 100%;
      height: auto;
      padding-bottom: 0.32rem;
      box-sizing: border-box;
      background: #fff;
      border-radius: 0.36rem;
      overflow: hidden;
      .top_info {
        box-sizing: border-box;
        margin-top: 0.28rem;
        display: flex;
        align-items: center;
        .my_icon {
          margin-left: 0.24rem;
          margin-right: 0.24rem;
          width: 0.96rem;
          height: 0.96rem;
          font-size: 0;
          overflow: hidden;
          border-radius: 0.96rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .vip_info {
          width: 5.1rem;
          .info_top {
            display: flex;
            align-items: center;
            .info_name {
              font-size: 0.32rem;
              color: #333333;
              font-weight: bold;
            }
            .info_time {
              margin-left: 0.16rem;
              width: 2.36rem;
              font-size: 0.22rem;
              color: #333333;
            }
            .vip_entry {
              margin-left: 0.16rem;
              width: 1.32rem;
              height: 0.44rem;
              font-size: 0;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .info_text {
            margin-top: 0.12rem;
            font-size: 0.28rem;
            color: #666666;
            letter-spacing: -0.01rem;
            span {
              color: #ff5500;
            }
          }
        }
      }
      .info_tips {
        width: 6.3rem;
        margin: 0 auto;
        margin-top: 0.1rem;
        font-size: 0.26rem;
        color: #333333;
        span {
          font-size: 0.26rem;
          color: #ff5500;
        }
      }
    }
  }
  .bottom_fixed {
    position: fixed;
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    padding-top: 0.2rem;
    width: 100%;
    height: 1.5rem;
    background: #ffffff;
    box-shadow: 0 0 0.16rem 0 rgba(0, 0, 0, 0.08);

    .bottom_btn {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 6.86rem;
      height: 0.92rem;
      background: #ff5500;
      border-radius: 0.16rem;
      font-size: 0.32rem;
      font-weight: bold;
      color: #ffffff;

      .icon_book {
        margin-top: 0.04rem;
        margin-right: 0.16rem;
        width: 0.32rem;
        height: 0.32rem;
        font-size: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
